import { TagGroup } from "../../../shared/models/tagGroup.model.ts";
import { getToken } from "../../../shared/utils/common.tsx";
import { TagGroupSerializer } from "../serializers/tagGroupSerializer.ts";

export class CommandGetTagGroups {
    async run() {       
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/core/tag_groups/`
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {'Content-Type': 'application/json', "Authorization": `Token ${getToken()} `}
                })
            .then(response =>  response.json())
            .then(json => json)
            .catch(err => console.log(err));
            if(response) {
                return this.deserialize(response);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any): TagGroup[] {
        const serializer = new TagGroupSerializer();
        return serializer.deserializeList(data);
    }
}
